module.exports = "<ticket-page></ticket-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/ticket.html
// module id = 1606
// module chunks = 0